<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">店铺管理</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="店铺名称">
          <el-input v-model="query.name" placeholder="店铺名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="query.typeId" placeholder="分类" clearable>
            <el-option v-for="item in shopTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option v-for="(v,k) in statusMap" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                     @click="submitQuery(1)">查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>店铺列表</span>
    </div>
    <el-table highlight-current-row :data="shops" border>
      <el-table-column align="center" label="序号" type="index"/>
      <el-table-column align="center" label="店铺图片">
        <template slot-scope="scope">
          <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
            <div slot="error" class="image-slot">
              <el-image title="加载失败"
                        src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="店铺名称" prop="name"/>
      <el-table-column align="center" label="联系人" prop="contactsPeople"/>
      <el-table-column align="center" label="联系电话" prop="contactsTelephone"/>
      <el-table-column align="center" label="座机电话" prop="landlineTelephone"/>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
            <div>{{statusMap[scope.row.status]}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="详细地址">
          <template slot-scope="scope">
              {{scope.row.province + scope.row.city + scope.row.area + scope.row.address}}
          </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini"
                     @click="$common.goRouterLink({ name: 'shopDetail', query: { shopId: scope.row.id }})">
            详情
          </el-button>
          <el-button type="danger" size="mini"
                     @click="del(scope.row.id)">
            删除
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <vue-pager :datafile="fillData" url="/shop/pageShop" :query="query" ref="pager"
               :init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      shops: [],
      dynamicPath:config.dynamicResourcePath,
      statusMap: {},
      shopTypes: [],
    }
  },
  created() {
    var statusMap = this.$common.cache('enum_config').EShopStatus
    statusMap.forEach(element => {
      this.statusMap[element.name] = element.label;
    });
    this.findShopType();
  },
  methods: {
    findShopType() {
      var _this = this;
      _this.$common.ajaxRequest({
          url: '/shopType/pageShopType',
          data: {
              limit: -1
          },
          success: resp => {
              _this.shopTypes = resp.items || [];
          }
      })
    },
    fillData(_response) {
      this.shops = _response.items || [];
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    del(_id) {
      var _this = this;
      _this
          .$confirm("是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.$common.ajaxRequest({
              url: '/shop/deleteShop',
              data: {
                shopId: _id
              },
              success(response) {
                _this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 1000,
                  onClose: function () {
                    _this.submitQuery(1);
                  }
                });
              }
            });
          })
    },
  },
}
</script>